/** Per-device "Focus mode" on Today (the Now card layout). ⇧F toggles it from the keyboard map. */
export const FOCUS_MODE_KEY = "today.focusMode";
